export default class BlockBanner {
	constructor() {

		let banner = document.querySelector('.banner');
		if (!banner) {
			return;
		}
		const swiper = banner.querySelector('.banner-gallery .swiper');
		if (!swiper) {
			return;
		}

		let options = {
			autoplay: {
				delay: 3000,
			},
			speed: 800,
			slidesPerView: "1",
			loop: true,
			allowTouchMove: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			}
		};

		new Swiper(swiper, options);
	}
}
